import type { ParsedUrlQuery } from "node:querystring";
import type { Dispatch, MutableRefObject, SetStateAction } from "react";
import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";

export enum LoginSection {
  ForgotPassword = "Forgot Password",
  Login = "Login",
  OTP = "OTP",
}

export interface IForgotPasswordError {
  hasForgotPasswordError: boolean;
  error: string;
}
export interface IFormInputsViewModel {
  labels: {
    title: string;
  };
  query: ParsedUrlQuery;
  currentSection: LoginSection;
  usernameRef: MutableRefObject<HTMLInputElement>;
  passwordRef: MutableRefObject<HTMLInputElement>;
  setCurrentSection: Dispatch<SetStateAction<LoginSection>>;
  forgotPasswordError: IForgotPasswordError;
}

export interface IForgotPasswordAlertViewModel {
  labels: {
    alertTitle: string;
  };
  classNames: {
    containerClassNames: string;
  };
  icon: IconDefinition;
  forgotPassword: (e: React.MouseEvent<HTMLElement>) => void;
  dataActive: boolean;
}

export interface IForgotPasswordAlertState {
  success: boolean;
  showAlert: boolean;
}
export interface IActionsViewModel {
  labels: {
    loginButtonTitle: string;
  };
  currentSection: LoginSection;
  usernameRef: MutableRefObject<HTMLInputElement>;
  passwordRef: MutableRefObject<HTMLInputElement>;
  onBackButtonHandler: (e: React.MouseEvent<HTMLElement>) => void;
  forgotPassword: (e: React.MouseEvent<HTMLElement>) => void;
  loginButtonOnClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export interface IFooterViewModel {
  labels: {
    needHelpText: string;
    teamText: string;
    getInTouchText: string;
    chatToUsText: string;
    issuesText: string;
    supportLink: string;
    chatLink: string;
    orText: string;
  };
}

export interface IOTPViewModel {
  labels: {
    title: string;
    codePlaceholder: string;
    backButtonText: string;
    loginButtonText: string;
  };

  OTPRef: MutableRefObject<HTMLInputElement>;
  OTPLoginButtonClick: (e: React.MouseEvent<HTMLElement>) => void;
  showOTPSection: boolean;
  onShowOTPSection: () => void;
  onBackButtonHandler: () => void;
}

export interface ILoginModel {
  forgotPasswordAlert: IForgotPasswordAlertState;
  labels: {
    title: string;
    subtitles: {
      key: string;
      title: string;
      onClick?: () => void;
    }[];
  };

  OTPViewModel: IOTPViewModel;

  formInputsViewModel: IFormInputsViewModel;

  forgotPasswordAlertViewModel: IForgotPasswordAlertViewModel;

  actionsViewModel: IActionsViewModel;

  footerViewModel: IFooterViewModel;
}
